// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"c81300e7","256":"fe52efe6","453":"cdc59319","546":"a55d9d13","889":"05417d30","902":"78bceb52","910":"54b1ac27","915":"38bfa5bd","929":"480eff6e"}[chunkId] + ".chunk.js";
};